import { render, staticRenderFns } from "./aiRecognitionStyle.vue?vue&type=template&id=6930e2cf&scoped=true"
import script from "./aiRecognitionStyle.vue?vue&type=script&lang=js"
export * from "./aiRecognitionStyle.vue?vue&type=script&lang=js"
import style0 from "./aiRecognitionStyle.vue?vue&type=style&index=0&id=6930e2cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6930e2cf",
  null
  
)

export default component.exports